import styled, { css } from 'styled-components';
import { palette, key } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

const fontSettings = {
  small: {
    size: key('sizes.font.tiny', '9px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.font.small', '10px'),
    spacing: '0.3px',
  },
  big: {
    size: key('sizes.font.normal', '14px'),
    spacing: '0px',
  },
};

const xlrFontSettings = {
  small: {
    size: key('sizes.xlrFont.tiny', '12px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.xlrFont.normal', '14px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.xlrFont.normal', '14px'),
    spacing: '0px',
  },
};

const xxlFontSettings = {
  small: {
    size: key('sizes.xxlFont.tiny', '11px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.xxlFont.normal', '14px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.xxlFont.normal', '14px'),
    spacing: '0px',
  },
};

const vxxlFontSettings = {
  small: {
    size: key('sizes.vxxlFont.tiny', '14px'),
    spacing: '0.3px',
  },
  normal: {
    size: key('sizes.vxxlFont.small', '16px'),
    spacing: '0.42px',
  },
  big: {
    size: key('sizes.vxxlFont.normal', '16px'),
    spacing: '0px',
  },
};

const sizes = {
  small: '30px',
  normal: '40px',
  big: '48px',
};

const xlrSizes = {
  small: '40px',
  normal: '40px',
  big: '48px',
};

const xxlSizes = {
  small: '40px',
  normal: '50px',
  big: '60px',
};

const vxxlSizes = {
  small: '40px',
  normal: '50px',
  big: '60px',
};

const colors = {
  error: '#FA8072',
};

export const StyledInputField = styled.input`
  outline: none;
  box-sizing: border-box;
  font-family: JetBrains Mono Regular;
  padding: 12px 16px;
  border: 1px solid ${palette('border', 0)};
  border-radius: ${key('sizes.borderRadius.tiny', '4px')};
  background-color: ${palette('background', 2)};
  height: ${(props) => sizes[props.sizevalue]};

  ${(props) => css`
    height: ${sizes[props.sizevalue]};
    font-size: ${fontSettings[props.sizevalue].size};
    letter-spacing: ${fontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.sm`
    height: ${sizes[props.sizevalue]};
    padding: 11px 10px;
  `}

  ${(props) => media.xlr`
  height: ${xlrSizes[props.sizevalue]};
  font-size: ${xlrFontSettings[props.sizevalue].size};
  letter-spacing: ${xlrFontSettings[props.sizevalue].spacing};
  padding: 11px 10px;
  `}

  ${(props) => media.xxl`
  height: ${xxlSizes[props.sizevalue]};
  font-size: ${xxlFontSettings[props.sizevalue].size};
  letter-spacing: ${xxlFontSettings[props.sizevalue].spacing};
  `}

  ${(props) => media.vxxl`
  height: ${vxxlSizes[props.sizevalue]};
  font-size: ${vxxlFontSettings[props.sizevalue].size};
  letter-spacing: ${vxxlFontSettings[props.sizevalue].spacing};
  `}
  
  width: 100%;

  color: ${palette('text', 1)};

  &::placeholder {
    font-size: ${fontSettings['big'].size};
    ${({ error }) =>
      error
        ? css`
            color: ${palette('error', 0)};
          `
        : css`
            color: ${palette('text', 5)};
            opacity: 1;
          `}
    ${media.xxl`
    font-size: ${xxlFontSettings['big'].size};
    `}
    ${media.vxxl`
    font-size: ${vxxlFontSettings['big'].size};
    `}
  }

  ${({ readOnly }) =>
    readOnly &&
    css`
      background: #e8e8eb;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      color: grey;
      &:hover,
      &:focus {
        border-color: #e8e8eb;
        box-shadow: #e8e8eb;
      }
      cursor: not-allowed;
    `}

  ${(props) =>
    props.color === 'error' &&
    css`
      border-color: ${colors[props.color]};
    `}
`;
